import { lazy } from 'react';

export const PatternStudioLivePageLazy = lazy(
    () => import('./pattern-studio-live-page'),
);
